<template>
    <div class="Graph Connector">
        <div class="container-fluid">
            <div class="row" v-if="!DisplayCode">
                <div class="col center-text">
                    <h2 :class="{'olive-green-text':ConnectionStatus=='Enabled', 'red':ConnectionStatus=='Disabled'}">{{ ConnectionStatus }}</h2>
                </div>
                <button @click="DisableConnection()" v-if="ConnectionStatus == 'Enabled'" class="form-control btn btn-secondary">CLICK TO DISABLE</button>
                <button @click="InitiateConnectionRequest()" v-if="ConnectionStatus == 'Disabled'" class="form-control btn btn-secondary">CLICK TO ENABLE</button>
            </div>
            <div class="row" v-if="DisplayCode">
                <div class="col center-text">
                    <p>Copy this Code:</p>
                    <p class="bold">{{ DeviceCodeValue }}</p>
                    <p>And Enter it Here:</p>
                    <p><a :href="DeviceLoginURL" target="_blank">{{ DeviceLoginURL }}</a></p>
                </div>
                <button @click="DisableConnection()" class="form-control btn btn-danger">CLICK TO CANCEL</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        created() {

        },
        props: [],
        data: function () {
            return {
                ConnectionStatus: "Checking...",
                DisplayCode: false,
                DeviceCodeValue: "",
                DeviceLoginURL: "https://login.microsoftonline.com/common/oauth2/deviceauth"
            };
        },
        methods: {
            GetConnectionStatus() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/GraphConnection/GetConnectionStatus", {}, this.GetConnectionStatusSuccess, ()=>{}, false)
            },
            GetConnectionStatusSuccess(response) {
                let vm = this;
                vm.ConnectionStatus = response.data.data.Message;
                if (vm.ConnectionStatus != "Pending") {
                    vm.DisplayCode = false;
                } else if (response.data.data.DeviceCode) {
                    vm.DeviceCodeValue = response.data.data.DeviceCode;
                    vm.DisplayCode = true;
                    setTimeout(function () { vm.GetConnectionStatus(); }, 5000);
                } else {
                    vm.DisplayCode = false;
                }
            },
            DisableConnection() {
                this.$MasterAPI.ExecuteRequest("POST", "Core/GraphConnection/DisableConnection", {}, this.DisableConnectionSuccess, () => { }, true);
            },
            DisableConnectionSuccess(response) {
                this.ConnectionStatus = response.data.data;
            },
            InitiateConnectionRequest() {
                this.$MasterAPI.ExecuteRequest("POST", "Core/GraphConnection/InitiateConnectionRequest", {}, this.InitiateConnectionRequestSuccess, () => { }, true);
            },
            InitiateConnectionRequestSuccess(response) {
                this.ConnectionStatus = response.data.data;
                let vm = this;
                setTimeout(function () { vm.PollForDeviceCode(5); }, 3000);
            },
            PollForDeviceCode(triesRemaining) {
                if (triesRemaining > 0) {
                    this.$MasterAPI.ExecuteRequest("GET", "Core/GraphConnection/PollForDeviceCode", {}, this.PollForDeviceCodeSuccess, () => { }, true);
                } else {
                    //end polling process and display error
                    this.GetConnectionStatus();
                    this.$store.commit("UI.BumpLoadsInProgress", -1);
                    EventBus.$emit('transmission-error', ["A Device Code Was Not able to be located."]);
                }
                
            },
            PollForDeviceCodeSuccess(response) {
                if (response.status == 200) {
                    if (response.data.data.Message == "Success") {
                        this.DeviceCodeValue = response.data.data.DeviceCode;
                        this.DisplayCode = true;
                        let vm = this;
                        //start polling for connection status ////////////////////////////////
                        setTimeout(function () { vm.GetConnectionStatus(); }, 5000);


                    } else {
                        setTimeout(function () { vm.PollForDeviceCode(triesRemaining - 1); }, 3000);
                    }
                }
            }
            
        },
        components: {
            
        },
        computed: {
            ConnectionStatusdel: function () {
                return "Disabledzzzz"
            }
        },
        mounted() {
            this.GetConnectionStatus()
        }
    }
</script>

<style scoped>
</style>